import { render } from "./InputTel.vue?vue&type=template&id=0d6123a1"
import script from "./InputTel.vue?vue&type=script&lang=js"
export * from "./InputTel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/InputTel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d6123a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d6123a1', __exports__)) {
    api.reload('0d6123a1', __exports__)
  }
  
  module.hot.accept("./InputTel.vue?vue&type=template&id=0d6123a1", () => {
    api.rerender('0d6123a1', render)
  })

}


export default __exports__